import $ from 'jquery';
import _ from 'lodash';
import React from "react";
import * as Misc from "./../../../misc";
import Config from "./../../../config";

const _isKiosk = Misc.toBoolean(document.kvConfig.kioskMode);
let _intervalId = 0;
const userIdleWarningTime = 30; // seconds after which user will get a warning
const userIdleTimeOutTime = 10; // seconds after which user will be redirect to the homepage

export default class TimerView extends React.Component {
  state = {
    visible: false,
    idleCounter: 0,
    count: 0,
    suspended: false
  };

  componentDidMount() {
    if (!_isKiosk) {
      console.log('No Kiosk, no timer!!!');
      return;
    }
    if (parent.document && Config.parent.$) {
      Config.parent.$(parent.document).on("Kiosk_componentVisible", (e, data) => {
        if (data.name !== 'QQ') {
          //console.log('QQ stop idle timer because invisible');
          this.setState({idleCounter: 0});
          clearInterval(_intervalId);
        }
      });
    }

    $(window).mousemove(() => {
      this.setState({idleCounter: 0});
    });
    $(window).keypress(() => {
      this.setState({idleCounter: 0});
    });
    $(window).on({
      "touchstart": () => {
        this.setState({idleCounter: 0});
      }
    });
    $(document).on('userIdleResetCounter', (e, data) => {
      this.setState({idleCounter: 0});
    });

    _intervalId = setInterval(this.handleTimer, 1000);
    console.log('Beware - timer start...');

    $(document).on('suspend_timer', this.suspendTimer);
    $(document).on('resume_timer', this.resumeTimer);
  }

  componentWillUnmount() {
    clearInterval(_intervalId);
    $(document).off('suspend_timer', this.suspendTimer);
    $(document).off('resume_timer', this.resumeTimer);
  }

  suspendTimer = () => {
    this.setState({
      idleCounter: 0,
      suspended: true
    });
    console.log('Suspending Timer');
  }

  resumeTimer = () => {
    this.setState({
      suspended: false
    });
    console.log('Resuming Timer');
  }

  resetKiosk = () => {
    if (_.has(window, 'resetKiosk')) {
      window.resetKiosk();
    } else {
      alert('Hey, resetKiosk is not set.');
    }
  };

  handleTimer = (e) => {
    if (Config.isTimeoutDisabled() || this.state.suspended) {
      return;
    }

    this.state.idleCounter++;
    //console.log('Timer', this.state.idleCounter);

    if (this.state.idleCounter >= userIdleWarningTime) {
      this.state.count = (userIdleTimeOutTime + userIdleWarningTime) - this.state.idleCounter;
    }

    if (this.state.idleCounter === userIdleWarningTime) {
      this.state.visible = true;
    } else if (this.state.idleCounter >= (userIdleTimeOutTime + userIdleWarningTime)) {
      clearInterval(_intervalId);
      this.resetKiosk();
      return;
    }

    this.setState(this.state);
  };

  handleGoHome = (e) => {
    Misc.ignoreDefault(e);
    this.resetKiosk();
  };

  handleResetCounter = (e) => {
    Misc.ignoreDefault(e);
    this.setState({idleCounter: 0, visible: false});
  };

  render() {
    if (!this.state.visible) {
      return null;
    }

    let countdown = 'Go Home';
    if (this.state.count > 0) {
      countdown += ' - ' + this.state.count;
    }
    return (
      <div>
        <div className='overlay'>
          <div className="overlay-content-middle">
            <p className='text-idle-title'>Would you still like to continue?</p>
            <div className='overlay-content-holder'>
              <button className='btn-idle-continue' onClick={this.handleResetCounter}>Continue</button>
              <button className='btn-idle-gohome' onClick={this.handleGoHome}>{countdown}</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
};




// WEBPACK FOOTER //
// ./src/components/common/timer/timerView.js